import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useHistory } from 'react-router-dom';
import { ErrorPanel, FullScreenOverlay } from '@nbirl/nbi-common-ui-libs';

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const history = useHistory();

  useEffect(() => {
    const unregister = history.listen(() => {
      resetErrorBoundary();
    });

    return () => {
      unregister();
    };
  }, [history, resetErrorBoundary]);

  return (
    <FullScreenOverlay>
      <ErrorPanel error={error} />
    </FullScreenOverlay>
  );
};
